import { COMMON_IGNORED_ERRORS, shouldIgnoreError } from '@insta-club/utilities/sentry';
import * as Sentry from '@sentry/nextjs';

export function initSentryClient() {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

        environment: process.env.NODE_ENV,
        enabled: process.env.NODE_ENV === 'production',
        debug: process.env.NODE_ENV === 'development',

        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false
            }),
            Sentry.browserTracingIntegration()
        ],

        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
        enableLogs: true,

        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        sendDefaultPii: true,

        beforeSend(event, hint) {
            if (process.env.NODE_ENV !== 'production') {
                console.log('Sentry Event (Dev):', event);
                return null;
            }

            if (shouldIgnoreError(hint.originalException, COMMON_IGNORED_ERRORS.client)) {
                return null;
            }

            if (event.level !== 'error' && event.level !== 'fatal') {
                return null;
            }

            if (event.exception) {
                event.tags = {
                    ...event.tags,
                    userAgent: navigator.userAgent,
                    url: window.location.href
                };
            }

            return event;
        },

        ignoreErrors: [...COMMON_IGNORED_ERRORS.client],

        denyUrls: [
            /extensions\//i,
            /^chrome:\/\//i,
            /^chrome-extension:\/\//i,
            /^moz-extension:\/\//i,
            /^resource:\/\//i,
            /^safari-extension:\/\//i
        ]
    });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

